module.exports = __webpack_public_path__ + "static/media/my-goal-bg.3fe1e817.svg";